module.exports = __webpack_public_path__ + "media/images/game/state-adac27cd15200afb9c0a815d9bc1c5ef.png";